import { render, staticRenderFns } from "./NotesAndReceipts.vue?vue&type=template&id=13f77b3c&"
import script from "./NotesAndReceipts.vue?vue&type=script&lang=js&"
export * from "./NotesAndReceipts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports